module.exports = __webpack_public_path__ + "img/logo_nuevo.fe365120.png";